// extracted by mini-css-extract-plugin
module.exports = {"title":"concept-doc-preview-module--title--mcZhq","description":"concept-doc-preview-module--description--cWhPu"};